const domainList: any = {
  'luqapay.com': {
    domain: 'luqapay.com',
    name: 'Luqapay',
    logoExists: false,
    logo: 'luqapay.png',
    favicon: 'luqapay.ico',
  },
  'speedy.io': {
    domain: 'speedy.io',
    name: 'Speedyteller',
    logoExists: true,
    logo: 'speedyteller.svg',
    favicon: 'speedyteller.ico',
  },
  'jetoncash.com': {
    domain: 'jetoncash.com',
    name: 'JetonCash',
    logoExists: false,
    logo: 'jetoncash.svg',
    favicon: 'jetoncash.ico',
  },
  'fastpayzone.com': {
    domain: 'fastpayzone.com',
    name: 'fastpayzone',
    logoExists: false,
    logo: 'fastpayzone.svg',
    favicon: 'fastpayzone.ico',
  },
  'easypaycircle.com': {
    domain: 'easypaycircle.com',
    name: 'easypaycircle',
    logoExists: false,
    logo: 'easypaycircle.svg',
    favicon: 'easypaycircle.ico',
  },
  'payeerfield.com': {
    domain: 'payeerfield.com',
    name: 'payeerfield',
    logoExists: false,
    logo: 'payeerfield.svg',
    favicon: 'payeerfield.ico',
  },
  'classicpay.net': {
    domain: 'classicpay.net',
    name: 'classicpay',
    logoExists: false,
    logo: 'classicpay.svg',
    favicon: 'classicpay.ico',
  },
  'tkbprocessing.com': {
    domain: 'tkbprocessing.com',
    name: 'tkbprocessing',
    logoExists: true,
    logo: 'tkbprocessing.png',
    favicon: 'tkbprocessing.ico',
  },
  'angelspay.io': {
    domain: 'angelspay.io',
    name: 'angelspay',
    logoExists: true,
    logo: 'angelspay.png',
    favicon: 'angelspay.ico',
  },
  'bankyprocessing.com': {
    domain: 'bankyprocessing.com',
    name: 'bankyprocessing',
    logoExists: true,
    logo: 'bankyprocessing.svg',
    favicon: 'banky.ico',
  },
  'bankyfast.com': {
    domain: 'bankyfast.com',
    name: 'bankyfast',
    logoExists: true,
    logo: 'bankyprocessing.svg',
    favicon: 'banky.ico',
  },
  'jeton.com': {
    domain: 'jeton.com',
    name: 'Jeton',
    logoExists: false,
    logo: 'jeton.svg',
    favicon: 'jeton.ico',
  },
  'jtnprocessing.com': {
    domain: 'jtnprocessing.com',
    name: 'jtnprocessing',
    logoExists: true,
    logo: 'jtnprocessing.svg',
    favicon: 'jeton.ico',
  },
  'hofi.app': {
    domain: 'hofi.app',
    name: 'Hofi',
    logoExists: true,
    logo: 'hofi.webp',
    favicon: 'hofi.ico',
  },
  'jeton47.com': {
    domain: 'jeton.com',
    name: 'Jeton',
    logoExists: false,
    logo: 'jeton.svg',
    favicon: 'jeton.ico',
  },
  'financialhouse.io': {
    domain: 'financialhouse.io',
    name: 'financialhouse',
    logoExists: false,
    logo: 'financialhouse.svg',
    favicon: 'financialhouse.ico',
    headerType: 'v2',
  },
  'kanky.app': {
    domain: 'kanky.app',
    name: 'Kanky',
    logoExists: true,
    logo: 'kanky.png',
    favicon: 'kanky.ico',
  },
  '1xpaybet.com': {
    domain: '1xpaybet.com',
    name: '1XBET',
    logoExists: true,
    logo: '1xpaybet.png',
    favicon: '1xpaybet.ico',
  },
  'ecopayzgateway.com': {
    domain: 'ecopayzgateway.com',
    name: 'Ecopayzgateway',
    logoExists: true,
    logo: 'ecopayzgateway.svg',
    favicon: 'ecopayzgateway.ico',
  },
  'centrueprocessing.com': {
    domain: 'centrueprocessing.com',
    name: 'Centrueprocessing',
    logoExists: true,
    logo: 'centrueprocessing.svg',
    favicon: 'centrueprocessing.ico',
  },
  'centrueprocessing.net': {
    domain: 'centrueprocessing.net',
    name: 'Centrueprocessing',
    logoExists: true,
    logo: 'centrueprocessing.svg',
    favicon: 'centrueprocessing.ico',
  },
  'webpayprocessing.com': {
    domain: 'webpayprocessing.com',
    name: 'Webpayprocessing',
    logoExists: false,
    logo: 'webpayprocessing.png',
    favicon: 'webpayprocessing.ico',
  },
  'flycheckout.net': {
    domain: 'flycheckout.net',
    name: 'Flycheckout',
    logoExists: true,
    logo: 'flycheckout.svg',
    favicon: 'flycheckout.ico',
  },
};

export default domainList;
